
function timeStamp(times) {
	let timestamp = Date.parse(new Date());
	times = Date.parse(new Date(times.replace(/-/g, '/'))) / 1000;
	timestamp = timestamp / 1000;
	let letime = times - timestamp;
	let time = parseInt(letime);
	if (time == 0) {
		return 0
	}

	if (parseInt(letime) > 60) {
		let second = parseInt(letime) % 60;
		let min = parseInt(letime / 60);
		// 直接返回字符串格式：
		// time = min + "分" + second + "秒";
		// 返回对象格式：
		time = {
			day: 0,
			min: min,
			second: second
		};
		if (min > 60) {
			min = parseInt(letime / 60) % 60;
			let hour = parseInt(parseInt(letime / 60) / 60);
			// 直接返回字符串格式：
			// time = hour + "时" + min + "分" + second + "秒";
			// 返回对象格式：
			time = {
				hour: hour,
				min: min,
				second: second
			}
			if (hour >= 24) {
				hour = parseInt(parseInt(letime / 60) / 60) % 24;
				let day = parseInt(parseInt(parseInt(letime / 60) / 60) / 24);
				// 直接返回字符串格式：
				// time = day + "天" + hour + "时" + min + "分" + second + "秒";
				// 返回对象格式：
				time = {
					day: day,
					hour: hour,
					min: min,
					second: second
				}
			}
		}
	} else {
		time = {
			day: 0,
			hour: 0,
			min: 0,
			second: letime
		}
	}

	// 判断是否小于10，小于10就补零
	if (time.day < 10) {
		time.day = '0' + time.day
	} else if (time.day == undefined) {
		time.day = '00'
	}
	if (time.hour < 10) {
		time.hour = '0' + time.hour
	} else if (time.hour == undefined) {
		time.hour = '00'
	}
	if (time.min < 10) {
		time.min = '0' + time.min
	} else if (time.min == undefined) {
		time.min = '00'
	}
	if (time.second < 10) {
		time.second = '0' + time.second
	}
	// 输出结果：
	return time;
}

// 交集
function array_intersect(a, b) {
	var sa = Array.from(new Set(a.map(v => parseInt(v))));
	var sb = Array.from(new Set(b.map(v => parseInt(v))));
	return sa.filter(x => sb.includes(x));
}
// 差集
function array_diff() {
	var sa = Array.from(new Set(a.map(v => parseInt(v))));
	var sb = Array.from(new Set(b.map(v => parseInt(v))));
	return sa.filter(x => !sb.includes(x));
}

function uuid() {
	let dt = new Date().getTime();
	const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		const r = (dt + Math.random() * 16) % 16 | 0;
		dt = Math.floor(dt / 16);
		return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
	});
	return uuid;
}

function test_image(filename) {
	const imageRegex = /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff)$/i;
	return imageRegex.test(filename);
}

function is_video(filename) {
	const videoRegex = /\.(mp4|mov|avi|wmv|flv|mkv|webm|ogv|ogg)$/i;
	return videoRegex.test(filename);
}

function downloadVideo(url) {
	// 跨域 OSS 文件通过 fetch → blob 下载，避免 download 属性被浏览器忽略
	const filename = url.split('/').pop() || 'video';
	fetch(url)
		.then(res => res.blob())
		.then(blob => {
			const blobUrl = URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = blobUrl;
			a.download = filename;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			URL.revokeObjectURL(blobUrl);
		})
		.catch(() => {
			window.open(url, '_blank');
		});
}

/**
 * 探测视频编码是否为浏览器可播放格式（H.264/AVC）。
 * 通过解析 MP4 文件头获取真实编码（avc1/hev1 等），准确判断浏览器兼容性。
 * @param {string} url 视频 URL
 * @returns {Promise<boolean>} true=可播放, false=需下载
 */
function probeVideoPlayable(url) {
	return new Promise((resolve) => {
		const ext = (url.split('.').pop() || '').toLowerCase();
		console.log('[probeVideoPlayable] 开始探测:', url, 'ext:', ext);
		if (['avi', 'wmv', 'flv'].includes(ext)) {
			console.log('[probeVideoPlayable] 后缀判定不可播放 → 下载');
			resolve(false);
			return;
		}
		if (!['mp4', 'mov', 'webm', 'mkv'].includes(ext)) {
			console.log('[probeVideoPlayable] 非标准容器，保守放行 → 预览');
			resolve(true);
			return;
		}

		console.log('[probeVideoPlayable] 标准容器，发起 Range 请求...');
		fetch(url, { headers: { Range: 'bytes=0-1048576' } })
			.then(function (res) {
				console.log('[probeVideoPlayable] Range 响应 status:', res.status);
				if (!res.ok) { resolve(true); return null; }
				return res.arrayBuffer();
			})
			.then(function (buffer) {
				if (!buffer || buffer.byteLength < 8) {
					console.log('[probeVideoPlayable] 缓冲区过小 → 预览');
					resolve(true);
					return;
				}
				console.log('[probeVideoPlayable] 收到', buffer.byteLength, '字节，开始解析...');
				var codec = parseMP4Codec(buffer);
				console.log('[probeVideoPlayable] 解析到 codec:', codec);
				if (!codec) {
					console.log('[probeVideoPlayable] 未找到视频 codec →', ['mp4', 'mov'].indexOf(ext) >= 0 ? '下载' : '预览');
					resolve(!(['mp4', 'mov'].indexOf(ext) >= 0));
					return;
				}
				var lc = codec.toLowerCase();
				if (lc === 'hev1' || lc === 'hvc1' || lc === 'hevc') {
					console.log('[probeVideoPlayable] 检测到 H.265/HEVC → 下载');
					resolve(false);
					return;
				}
				if (lc === 'av01') {
					console.log('[probeVideoPlayable] 检测到 AV1 → 下载');
					resolve(false);
					return;
				}
				console.log('[probeVideoPlayable] 编码兼容 → 预览');
				resolve(true);
			})
			.catch(function (e) {
				console.log('[probeVideoPlayable] fetch 异常:', e, '→ 预览');
				resolve(true);
			});
	});
}

function readFourCC(view, offset) {
	return String.fromCharCode(
		view.getUint8(offset),
		view.getUint8(offset + 1),
		view.getUint8(offset + 2),
		view.getUint8(offset + 3)
	);
}

function parseMP4Codec(buffer) {
	var view = new DataView(buffer);
	var size = buffer.byteLength;
	var offset = 0;

	while (offset + 8 <= size) {
		var boxSize = view.getUint32(offset);
		var boxType = readFourCC(view, offset + 4);
		if (boxType === 'moov') {
			return searchSTSD(view, offset + 8, Math.min(offset + boxSize, size));
		}
		offset += boxSize;
	}
	return null;
}

function searchSTSD(view, start, end) {
	var offset = start;
	while (offset + 8 <= end) {
		var boxSize = view.getUint32(offset);
		var boxType = readFourCC(view, offset + 4);
		if (boxSize <= 0) break;

		if (boxType === 'stsd') {
			if (offset + 20 <= end) {
				var entryCount = view.getUint32(offset + 12);
				if (entryCount > 0) {
					return readFourCC(view, offset + 20);
				}
			}
			return null;
		}

		var containers = ['moov', 'trak', 'mdia', 'minf', 'stbl'];
		if (containers.indexOf(boxType) >= 0) {
			var result = searchSTSD(view, offset + 8, Math.min(offset + boxSize, end));
			if (result) return result;
		}

		offset += boxSize;
	}
	return null;
}

function get_image_icon(filename) {
	// console.log('filename',filename);
	let ext = '';
	if(filename){
		ext = filename.substring(filename.lastIndexOf('.') + 1);
	}
	switch (ext.toLowerCase()) {
		case "doc":
		case "docx":
			return require(`@/assets/images/design/file/word.png`)
		case "csv":
		case "xls":
		case "xlsx":
			return require(`@/assets/images/design/file/excel.png`)
		case "ppt":
			return require(`@/assets/images/design/file/ppt.png`)
		case "ai":
			return require(`@/assets/images/design/file/ai.png`)
		case "avi":
			return require(`@/assets/images/design/file/avi.png`)
		case "mp4":
			return require(`@/assets/images/design/file/mp4.png`)
		case "pdf":
			return require(`@/assets/images/design/file/pdf.png`)
		case "psd":
			return require(`@/assets/images/design/file/psd.png`)
		case "cdr":
			return require(`@/assets/images/design/file/cdr.png`)
		case "wav":
			return require(`@/assets/images/design/file/wav.png`)
		case "rar":
		case "zip":
			return require(`@/assets/images/design/file/zip.png`)
		default:
			return require(`@/assets/images/design/file/default.png`)
	}
}

function is_pattern_file(filename){
	const fileType = [
		'pjh','plt','boke','prj','ets','dgs','pds','fgs','gmt','bpd','gph',
		'tmp','zip','mdl','pa1','pa2','pa3','pat','sty','sg','jit','ftd',
		'sak','skc','aud','pdt','pan','pax','dxf','aama','inv'
	];
	const file = filename.split('.').pop().toLowerCase();
	return fileType.includes(file);
}

function checkAvifSupport() {
	const stored = window.localStorage.getItem('avifSupported');
	if (stored !== null) {
		return stored === 'true';
	}
	
	const img = new Image();
	img.onload = function() {
		window.localStorage.setItem('avifSupported', 'true');
	};
	img.onerror = function() {
		window.localStorage.setItem('avifSupported', 'false');
	};
	img.src = 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=';
	
	return false;
}

// 计算预售商品发货剩余天数
function calcRemainDays(create_time, presale_delivery_days) {
	const days = Number(presale_delivery_days);
	if (!days || !create_time) return `${days || 0}天内发货`;
	const start = new Date(String(create_time).replace(/-/g, '/')).getTime();
	const passed = Math.floor((Date.now() - start) / (1000 * 60 * 60 * 24));
	const remain = days - passed;
	return remain > 0 ? `${remain}天内发货` : '已到发货时间';
}

// ==================== 视频预览 ====================
let _previewStylesInjected = false;
function _injectPreviewStyles() {
	if (_previewStylesInjected) return;
	const style = document.createElement('style');
	style.textContent = `
		.video-preview-mask {
			position: fixed; top: 0; left: 0; width: 100%; height: 100%;
			background: rgba(0, 0, 0, 0.85); z-index: 9999;
			display: flex; align-items: center; justify-content: center;
		}
		.video-preview-container {
			position: relative; width: 100%; height: 100%;
			display: flex; align-items: center; justify-content: center;
		}
		.video-preview-close {
			position: absolute; top: 24px; right: 24px;
			width: 40px; height: 40px; line-height: 36px; text-align: center;
			font-size: 28px; color: #fff; cursor: pointer; z-index: 10;
			background: rgba(0, 0, 0, 0.5); border-radius: 50%;
			transition: background 0.2s;
		}
		.video-preview-close:hover { background: rgba(0, 0, 0, 0.8); }
		.video-wrapper-fix {
			position: relative; width: 100%; height: 100%;
			display: flex; align-items: center; justify-content: center;
		}
		.video-wrapper-fix video { max-width: 90vw; max-height: 80vh; }
		.video-wrapper-fix video::-webkit-media-controls-panel { display: flex !important; }
		.video-wrapper-fix video::-webkit-media-controls-overlay-play-button { display: none !important; }
		.video-wrapper-fix video::cue { display: none !important; }
		video[controls]::-internal-media-controls-overlay-cast-button,
		video[controls]::-webkit-media-controls-overlay-play-button { display: none !important; }
		.video-preview-loading {
			display: flex; flex-direction: column; align-items: center; row-gap: 16px;
		}
		.video-loading-spinner {
			width: 40px; height: 40px;
			border: 3px solid rgba(255, 255, 255, 0.3);
			border-top-color: #fff; border-radius: 50%;
			animation: video-preview-spin 0.8s linear infinite;
		}
		@keyframes video-preview-spin { to { transform: rotate(360deg); } }
		.video-detect-text { color: #fff; font-size: 14px; }
		.video-unplayable-box {
			display: flex; flex-direction: column; align-items: center;
			row-gap: 12px; cursor: pointer; padding: 24px;
		}
		.video-unplayable-box .hint-text { color: #fff; font-size: 14px; }
		.video-unplayable-box .download-link {
			color: #4d8aff; font-size: 16px; text-decoration: underline;
		}
	`;
	document.head.appendChild(style);
	_previewStylesInjected = true;
}

/**
 * 关闭视频预览弹窗
 */
function closeVideoPreview() {
	const mask = document.querySelector('.video-preview-mask');
	if (mask) mask.remove();
}

/**
 * 预览视频：先探测编码兼容性，可播放则内联播放，否则提示下载
 * @param {string} url 视频 URL
 */
function previewVideo(url) {
	// 先移除可能存在的旧预览
	closeVideoPreview();
	// 注入样式（仅一次）
	_injectPreviewStyles();

	// 创建遮罩 DOM
	const mask = document.createElement('div');
	mask.className = 'video-preview-mask';

	const container = document.createElement('div');
	container.className = 'video-preview-container';

	const closeBtn = document.createElement('div');
	closeBtn.className = 'video-preview-close';
	closeBtn.textContent = '×';

	const wrapper = document.createElement('div');
	wrapper.className = 'video-wrapper-fix';
	wrapper.innerHTML = `
		<div class="video-preview-loading">
			<div class="video-loading-spinner"></div>
			<span class="video-detect-text">视频文件检测中...</span>
		</div>
	`;

	container.appendChild(closeBtn);
	container.appendChild(wrapper);
	mask.appendChild(container);
	document.body.appendChild(mask);

	// 事件绑定
	mask.addEventListener('click', function (e) {
		if (e.target === mask) closeVideoPreview();
	});
	closeBtn.addEventListener('click', function (e) {
		e.stopPropagation();
		closeVideoPreview();
	});
	container.addEventListener('click', function (e) {
		e.stopPropagation();
	});

	// 探测可播放性
	probeVideoPlayable(url).then(function (playable) {
		// 预览已被关闭则不处理
		if (!mask.parentNode) return;

		if (playable) {
			wrapper.innerHTML = `<video src="${url}" controls autoplay class="video-preview" disablepictureinpicture controlslist="nodownload"></video>`;
		} else {
			wrapper.innerHTML = `
				<div class="video-unplayable-box">
					<span class="hint-text">该视频只支持下载预览</span>
					<span class="download-link">点击下载</span>
				</div>
			`;
			const box = wrapper.querySelector('.video-unplayable-box');
			box.addEventListener('click', function (e) {
				e.stopPropagation();
				downloadVideo(url);
			});
		}
	});
}

/**
 * 带鉴权的 Excel 导出下载：POST 请求并以 blob 形式接收响应，触发浏览器下载。
 * @param {string} url 接口地址（相对 BASE_API，如 '/shop/invoice/handle-export'）
 * @param {object} data 请求体
 * @param {string} token 鉴权 token（Bearer）
 * @param {string} label 下载文件名前缀（自动追加时间戳）
 * @returns {Promise<void>}
 */
function downloadExcel(url, data, token, label) {
	const axios = require('axios');
	const base = process.uniEnv.BASE_API;
	return axios({
		method: 'post',
		url: base + url,
		data: data || {},
		responseType: 'blob',
		headers: { Authorization: 'Bearer ' + (token || '') },
	}).then((res) => {
		const ct = (res.headers && (res.headers['content-type'] || res.headers['Content-Type'])) || '';
		// 后端返回 JSON（多为错误提示）时解析并抛出
		if (ct.indexOf('json') !== -1) {
			return res.data.text().then((txt) => {
				let msg = '导出失败';
				try {
					const j = JSON.parse(txt);
					msg = j.msg || msg;
				} catch (e) {
					msg = txt || msg;
				}
				return Promise.reject(new Error(msg));
			});
		}
		const blob = res.data;
		const d = new Date();
		const pad = (n) => (n < 10 ? '0' + n : '' + n);
		const ts = '' + d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()) +
			pad(d.getHours()) + pad(d.getMinutes()) + pad(d.getSeconds());
		const filename = (label || '导出') + ts + '.xlsx';
		const blobUrl = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = blobUrl;
		a.download = filename;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		URL.revokeObjectURL(blobUrl);
	});
}

module.exports = {
	timeStamp,
	array_intersect,
	array_diff,
	uuid,
	test_image,
	get_image_icon,
	is_video,
	downloadVideo,
	probeVideoPlayable,
	is_pattern_file,
	checkAvifSupport,
	calcRemainDays,
	previewVideo,
	closeVideoPreview,
	downloadExcel
}
